import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.jsx';
import { ThemeProvider } from './lib/theme.jsx';
import { UiVariantProvider } from './lib/uiVariant.jsx';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15_000 },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root non trovato');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <UiVariantProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </UiVariantProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
